import React from 'react';
import { Container, Form, Header, Divider} from 'semantic-ui-react';
import ModelSelect from './ModelSelect';
import ModelSettings from './ModelSettings';
import SimSettings from './SimSettings';
import "semantic-ui-css/semantic.min.css";

class JForm extends React.Component {
	constructor(props) {
		super(props)

        let step = 1;
        let modeltype = null;

        // Set State
        this.state = {step : step,
            modeltype : modeltype,
            simtypes : [],
            primary : {}};
        
        this.updateModelType = this.updateModelType.bind(this);
        this.liftJSON = this.liftJSON.bind(this);
        this.updateStep = this.updateStep.bind(this);
        this.attrUpdate = this.attrUpdate.bind(this);
        this.addSim = this.addSim.bind(this);
        this.delSim = this.delSim.bind(this);
	}

    liftJSON() {
        this.props.jsonUpdate(this.state.primary);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.primary !== prevState.primary){
            let {step} = prevState
            if (Object.keys(nextProps.primary["FLOW_MODEL_TYPE"]).length > 0 && prevState.step < 2) {
                step = 2;
            }
            return({primary : nextProps.primary,
                    step : step});
        } else {
            return null;
        }
    }

    updateStep(minstep) {
        if (this.state.step < minstep) {
            this.setState({step : minstep})
        }
    }
    
    updateModelType(e,d) {
        const {primary} = this.state;
        let value = d.value;
        // Set local
        this.setState({modeltype : value});
        this.updateStep(2);
        // Update Primary & lift up state
        primary["FLOW_MODEL_TYPE"] = {};
        primary["FLOW_MODEL_TYPE"][value] = {};
        this.setState({primary : primary});
        this.liftJSON();
    }

    addSim() {
        const {primary} = this.state;
        primary["SIMULATIONS"].push({"PATHLINE" : {}});
        this.setState({primary : primary});
        this.liftJSON();
    }

    delSim(index) {
        const {primary} = this.state;
        primary["SIMULATIONS"].splice(index, 1);
        this.setState({primary : primary});
        this.liftJSON();
    }

    attrUpdate(target, value) {
        const {primary} = this.state;
        let loc = primary;
        // Find location one out from the value
        for (var i=0; i < target.length-1; i++) {
            loc = loc[target[i]];
            if (loc === undefined) {
                console.log("Error updating value! Target=", target)
            }
        }
        // Add or update value
        if (value === "" || (typeof(value)==="number" && isNaN(value))) {
            // Catch empty - remove instead
            delete loc[target[target.length - 1]];
        } else {
            loc[target[target.length - 1]] = value;
        }
        this.setState({primary : primary});
        this.liftJSON();
    }

	render() {
        let modeltypes = this.props.options.modeltypes;
        let {primary} = this.props;
        let modeltype = Object.keys(primary["FLOW_MODEL_TYPE"])[0];
        let options = this.props.options;

		return (
            <Container>
                
                <Form>
                    <Header size='medium'>Model Type</Header>
                    <ModelSelect modeltype={modeltype} modeltypes={modeltypes} onChange={this.updateModelType} />
                    <Divider />
                    {this.state.step > 1 && <ModelSettings primary={primary} options={options} onChange={this.attrUpdate}/>}
                    {this.state.step > 1 && <Divider /> }
                    {this.state.step > 1 && <SimSettings options={options}
                                                        step={this.state.step}
                                                        updateStep={this.updateStep}
                                                        simulations={primary['SIMULATIONS']}
                                                        addSim={this.addSim}
                                                        delSim={this.delSim}
                                                        onChange={this.attrUpdate}/>}
                    {this.state.step >1 && <Divider /> }
                    
                </Form>
            </Container>
        );
	}

}

//<Dropdown placeholder='Model Type' onChange={this.updateModelType} options={modeltypes} />

export default JForm;